import styled from '@emotion/styled';

import { orangeButtonStyles } from '~/src/components/buttons/button-styles';
import { darkGrey, fontWeight } from '~/styles';

export const Heading = styled.h2`
  color: ${darkGrey};
  font-size: 18px;
  font-weight: ${fontWeight.bold};
  line-height: 27px;
  letter-spacing: 0.02em;
  text-align: center;
  text-transform: uppercase;
`;

export const Button = styled.button`
  ${orangeButtonStyles}
`;
